import React, { useState, useEffect } from "react";
import PortfolioAdmin from "./PortfolioAdmin";
import JobsAdmin from "./JobsAdmin";
import LeadsAdmin from "./LeadsAdmin";
import ClientsAdmin from "./ClientsAdmin";
import ReviewsAdmin from "./ReviewsAdmin";
import CraftAdmin from "./CraftAdmin";
import FaqAdmin from "./FaqAdmin";
import AdminLogin from "./AdminLogin";
import GrassurnLogo from "./GrassurnLogo";
import { FolderOpen, Briefcase, Mail, Users, Star, LogOut, Wand2, HelpCircle } from "lucide-react";

const NAV_ITEMS = [
  { id: "portfolio", label: "Portfolio",    icon: FolderOpen,  component: PortfolioAdmin },
  { id: "jobs",      label: "Jobs",         icon: Briefcase,   component: JobsAdmin },
  { id: "leads",     label: "Leads",        icon: Mail,        component: LeadsAdmin },
  { id: "clients",   label: "Our Clients",  icon: Users,       component: ClientsAdmin },
  { id: "reviews",   label: "Reviews",      icon: Star,        component: ReviewsAdmin },
  { id: "craft",     label: "Craft",        icon: Wand2,       component: CraftAdmin },
  { id: "faq",       label: "FAQ",          icon: HelpCircle,  component: FaqAdmin },
];

const Sidebar = ({ activeTab, onTabChange, onLogout }) => (
  <div style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: 200,
    height: "100vh",
    background: "#0A0A0A",
    borderRight: "1px solid #1a1a1a",
    display: "flex",
    flexDirection: "column",
    zIndex: 20
  }}>
    {/* Logo mark */}
    <div style={{ padding: "24px 20px 20px", borderBottom: "1px solid #1a1a1a" }}>
      <div style={{ transform: "scale(0.7)", transformOrigin: "left center" }}>
        <GrassurnLogo />
      </div>
    </div>

    {/* Nav items */}
    <nav style={{ flex: 1, padding: "16px 12px" }}>
      {NAV_ITEMS.map(item => {
        const Icon = item.icon;
        const isActive = activeTab === item.id;
        return (
          <button
            key={item.id}
            onClick={() => onTabChange(item.id)}
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "10px 12px",
              borderRadius: 6,
              border: "none",
              cursor: "pointer",
              background: isActive ? "rgba(45,92,90,0.25)" : "transparent",
              color: isActive ? "#fff" : "rgba(255,255,255,0.35)",
              fontFamily: "Montserrat, sans-serif",
              fontWeight: isActive ? 500 : 300,
              fontSize: 13,
              textAlign: "left",
              marginBottom: 2,
              transition: "all 0.15s",
              position: "relative"
            }}
          >
            {isActive && (
              <div style={{
                position: "absolute",
                left: 0,
                top: "50%",
                transform: "translateY(-50%)",
                width: 3,
                height: 16,
                background: "#5B9490",
                borderRadius: "0 2px 2px 0"
              }} />
            )}
            <Icon size={15} />
            {item.label}
          </button>
        );
      })}
    </nav>

    {/* Logout */}
    <div style={{ padding: "16px 12px", borderTop: "1px solid #1a1a1a" }}>
      <button
        onClick={onLogout}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "10px 12px",
          borderRadius: 6,
          border: "none",
          cursor: "pointer",
          background: "transparent",
          color: "rgba(255,255,255,0.2)",
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 300,
          fontSize: 13,
          textAlign: "left",
          transition: "color 0.15s"
        }}
        onMouseEnter={e => e.currentTarget.style.color = "#f87171"}
        onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.2)"}
      >
        <LogOut size={15} />
        Logout
      </button>
    </div>
  </div>
);

const Admin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [activeTab, setActiveTab] = useState("portfolio");

  useEffect(() => {
    const authStatus = sessionStorage.getItem("grassurn_admin_auth");
    if (authStatus === "true") setIsAuthenticated(true);
  }, []);

  const handleLogin = (success) => {
    if (success) {
      setIsAuthenticated(true);
      sessionStorage.setItem("grassurn_admin_auth", "true");
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    sessionStorage.removeItem("grassurn_admin_auth");
    setActiveTab("portfolio");
  };

  if (!isAuthenticated) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  const ActiveComponent = NAV_ITEMS.find(item => item.id === activeTab)?.component;

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#F9FAFB" }}>
      <Sidebar activeTab={activeTab} onTabChange={setActiveTab} onLogout={handleLogout} />
      <main style={{ marginLeft: 200, flex: 1, padding: "40px 48px", minHeight: "100vh" }}>
        {ActiveComponent && <ActiveComponent />}
      </main>
    </div>
  );
};

export default Admin;
